'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function Controller($filter, $scope, $state, $window, AppConstants, PageHeading, PromotionComponent, Toast, Promotion) {
	'ngInject';

	var vm = this;

	vm.removeComponent = removeComponent;
	vm.getPaginationInfo = PromotionComponent.getPaginationInfo();
	vm.getPromotion = PromotionComponent.getPromotion;
	vm.promotion = Promotion;

	activate();

	function activate() {
		var heading = $filter('translate')('HEADING.PROMOTION_LINES');
		var title = 'BTMS | ' + $filter('translate')('HEADING.PROMOTION_LINES');

		PageHeading.setPageHeading(heading, title);
	}

	function removeComponent(componentId, componentType) {
		if ($window.confirm($filter('translate')('CONFIRM.DELETE'))) {
			PromotionComponent.removeComponent(Promotion.id, componentId, componentType).then(function (res) {
				if (res.data.errors) {
					Toast.responseError(res.data.errors);
				} else {
					if (componentType === 'line') {
						Toast.success($filter('translate')('SUCCESS.LINE_REMOVED_TO_PROMOTION'));
					} else {
						Toast.success($filter('translate')('SUCCESS.SUB_LINE_REMOVED_TO_PROMOTION'));
					}

					PromotionComponent.fetchPromotion(Promotion.id, 'translation,lines,subLines');
				}
			});
		}
	}
}

exports['default'] = Controller;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/private/promotions/edit-lines/list/list.controller.js
 **/